import { blogArticles } from "../data/blogArticles";
import {
  blogCategories,
  blogTagLinks,
  categoryArticles,
  getAllBlogIndexArticles,
  getArticlesByTag,
} from "../data/blogIndexData";
import { tourDetails } from "../data/tours";
import { blogText } from "../i18n/blog";
import { INSTAGRAM_URL } from "../config/socialLinks";
import { getLocalizedValue, localizeArticle } from "./localizedContent";
import { getOceanPlaceSeo } from "./oceanPlacePages.mjs";
import { HOTEL_GUIDE_PATH, hotelGuideSeo } from "../data/miyakoHotels.mjs";

export const SITE_URL = "https://premium-tour-miyako.com";
export const SITE_NAME = "Premium Tour Miyakoisland";
export const DEFAULT_IMAGE = `${SITE_URL}/images/ogp.png`;
const ITINERARY_IMAGE =
  "https://res.cloudinary.com/drxijtp8g/image/upload/c_fill,w_1200,h_630,q_auto,f_jpg/v1784766584/DJI_20260721090315_0012_D_nm08ha.webp";
const DEFAULT_KEYWORDS = [
  "宮古島",
  "宮古島旅行",
  "宮古島観光",
  "宮古島フォトツアー",
  "ドローン撮影",
  "絶景スポット",
];
const LANGUAGE_STORAGE_KEY = "premium-tour-miyako-language";
const LOCALE_MAP = {
  JP: "ja_JP",
  EN: "en_US",
  中文: "zh_CN",
  한국어: "ko_KR",
};
const LANG_PATH_MAP = { JP: "", EN: "en", 中文: "zh", 한국어: "ko" };
const PATH_LANG_MAP = { en: "EN", zh: "中文", ko: "한국어" };
const URL_HREFLANG_MAP = { JP: "ja", EN: "en", 中文: "zh", 한국어: "ko" };

const defaultDescription =
  "宮古島の絶景スポットや秘境ビーチを巡る、1日1組限定の貸切プライベートフォトツアー。ドローン撮影、一眼カメラ撮影、SUP、シュノーケルを組み合わせて、特別な旅の思い出を最高の形で残します。";

const routeSeo = {
  "/": {
    title:
      "宮古島の絶景・秘境フォトツアー｜貸切ドローン撮影 Premium Tour Miyakoisland",
    description: defaultDescription,
  },
  "/tours": {
    title: "宮古島フォトツアー一覧｜貸切・ドローン撮影付き",
    description:
      "宮古島の絶景巡り、SUP、シュノーケル、サンセット撮影など、写真・動画撮影付きの貸切プライベートツアーを紹介します。",
  },
  "/gallery": {
    title: "宮古島フォト・動画ギャラリー｜Premium Tour Miyakoisland",
    description:
      "宮古島の海、秘境ビーチ、ドローン映像、旅のショートムービーをギャラリーで紹介します。撮影付きツアーの雰囲気をご覧ください。",
  },
  "/faq": {
    title: "よくある質問｜宮古島貸切フォトツアー",
    description:
      "宮古島の貸切フォトツアーに関する料金、撮影内容、送迎、予約、雨天時の対応など、よくある質問をまとめています。",
  },
  "/contact": {
    title: "お問い合わせ・予約相談｜宮古島フォトツアー",
    description:
      "宮古島の貸切フォトツアー、ドローン撮影、SUP、シュノーケル、撮影プランについてのお問い合わせ・予約相談はこちら。",
  },
  "/web-production": {
    title: "宮古島最安級のWeb制作・ホームページ制作｜運用費・管理費0円",
    description:
      "宮古島最安級のホームページ制作・Web制作。通常価格400,000円のところ、残り1社様限定のキャンペーン価格200,000円。公開後の運用費・管理費0円。地域事業者に特化して設計します。",
    keywords: [
      "宮古島 Web制作",
      "宮古島 Web制作 最安",
      "宮古島 Web制作 運用費0円",
      "宮古島 ホームページ 管理費0円",
      "宮古島 ホームページ制作",
      "宮古島 ウェブ制作",
      "宮古島 ホームページ作成",
      "宮古島 サイト制作",
      "宮古島 Webデザイン",
      "宮古島 SEO",
      "宮古島 MEO",
      "宮古島 Googleマップ 集客",
      "宮古島 Googleビジネスプロフィール",
      "宮古島 多言語サイト",
      "宮古島 予約サイト",
    ],
    schemaType: "professionalService",
    singleLanguage: true,
  },
  "/shigira-concierge-demo": {
    title: "SHIGIRA Stay Guide｜天候連動型滞在コンシェルジュ デモ",
    description:
      "シギラリゾートの既存予約サービスに、天気・風・海況から今日の過ごし方を提案する機能を追加するための非公式コンセプトデモです。",
    keywords: ["シギラ コンシェルジュ デモ", "宮古島 リゾート DX"],
    singleLanguage: true,
    noindex: true,
  },
  "/miyako-work-demo": {
    title: "宮古島で働く｜求人プラットフォーム コンセプトデモ",
    description: "宮古島で働きたい女性向けに、寮・給与・送迎・勤務条件を比較してLINEから相談できる採用プラットフォームのコンセプトデモです。",
    noindex: true,
  },
  "/admin": {
    title: "Ocean Guide 管理",
    description: "Ocean Guideの管理画面です。",
    singleLanguage: true,
    noindex: true,
  },
  "/test": {
    title: "開発確認ページ",
    description: "開発確認用のページです。",
    singleLanguage: true,
    noindex: true,
  },
  "/blog": {
    title: "宮古島観光ブログ｜カフェ・ビーチ・映えスポット情報",
    description:
      "宮古島旅行で行きたいカフェ、ビーチ、雨の日スポット、サンセット、撮影におすすめの場所を紹介する観光ブログです。",
  },
  "/itinerary": {
    title: "宮古島旅行日程モデルコース｜Google Mapで巡る旅のしおり",
    description:
      "宮古島旅行の日程をDayごとにまとめ、各スポットや1日のルートをGoogle Mapで開ける旅のしおりページです。カフェ、絶景、夜ご飯、ツアー予定を見やすく整理できます。",
    keywords: [
      "宮古島 旅行日程",
      "宮古島 モデルコース",
      "宮古島 Google Map",
      "宮古島 旅のしおり",
      "宮古島 観光ルート",
      ...DEFAULT_KEYWORDS,
    ],
    schemaType: "itinerary",
    image: ITINERARY_IMAGE,
  },
  "/ocean-guide": {
    title: "宮古島の今日の海況・天気・台風情報｜シュノーケル・ビーチを毎日案内 | Miyako Ocean Guide",
    description:
      "宮古島の今日・明日の海況、天気、台風の進路と影響、風、波、うねりを毎日更新。シュノーケルやビーチにおすすめの場所と注意点を確認できます。",
    keywords: [
      "宮古島 海況",
      "宮古島 今日 海",
      "宮古島 シュノーケル 今日",
      "宮古島 波 予報",
      "宮古島 風向き ビーチ",
      "宮古島 明日 海況",
      "宮古島 台風",
      "宮古島 台風 進路",
      "宮古島 台風 海況",
      "宮古島 海遊び",
      "宮古島 シュノーケル",
      "宮古島 SUP",
      "宮古島 星空",
      "宮古島 雨の日",
      "宮古島 天気",
      "宮古島 潮位",
      "宮古島 グルメ",
      "宮古島 カフェ",
      ...DEFAULT_KEYWORDS,
    ],
    image:
      "https://res.cloudinary.com/drxijtp8g/image/upload/c_fill,w_1200,h_630,q_auto,f_jpg/v1784944008/DJI_20260724142728_0046_D_fjvofb.webp",
    schemaType: "oceanGuide",
  },
  "/ocean-guide/snorkeling": {
    title: "宮古島のシュノーケルガイド｜おすすめビーチ・海況・注意点",
    description: "宮古島でシュノーケルを楽しむためのおすすめビーチ、海況の見方、風・波・うねりの確認方法を紹介します。",
    keywords: ["宮古島 シュノーケル", "宮古島 シュノーケル おすすめ", "宮古島 海況", ...DEFAULT_KEYWORDS],
    singleLanguage: true,
  },
  "/ocean-guide/beach": {
    title: "宮古島のビーチ遊びガイド｜おすすめの海・風向き・過ごし方",
    description: "宮古島のビーチ遊びにおすすめの場所と、風向き、潮位、海況の見方を紹介します。",
    keywords: ["宮古島 ビーチ", "宮古島 おすすめビーチ", "宮古島 海遊び", ...DEFAULT_KEYWORDS],
    singleLanguage: true,
  },
  "/ocean-guide/stargazing": {
    title: "宮古島の星空ガイド｜おすすめ時間・月明かり・星空スポット",
    description: "宮古島で星空を見るためのおすすめ時間、月明かり、雲量、風、星空スポットを紹介します。",
    keywords: ["宮古島 星空", "宮古島 星空スポット", "宮古島 星 おすすめ時間", ...DEFAULT_KEYWORDS],
    singleLanguage: true,
  },
  "/ocean-guide/sunset": {
    title: "宮古島のサンセットガイド｜日の入り時間・おすすめスポット",
    description: "宮古島の日の入り時間、サンセットを楽しみやすい時間とおすすめスポットを紹介します。",
    keywords: ["宮古島 サンセット", "宮古島 夕日", "宮古島 日の入り", ...DEFAULT_KEYWORDS],
    singleLanguage: true,
  },
  "/ocean-guide/snorkeling-today": {
    title: "宮古島で今日シュノーケルできる？｜今日の海況とおすすめビーチ",
    description: "今日の宮古島の天気、降水確率、風、波を確認し、シュノーケルにおすすめの場所をOcean Guideで探せます。",
    keywords: ["宮古島 シュノーケル 今日", "宮古島 今日 海", "宮古島 海況", ...DEFAULT_KEYWORDS],
    singleLanguage: true,
  },
  "/ocean-guide/windy-day-beaches": {
    title: "風が強い日におすすめの宮古島ビーチ｜風向き・波を確認",
    description: "宮古島で風が強い日に、風向きと波の影響を確認して比較的穏やかなビーチを探すためのガイドです。",
    keywords: ["宮古島 風が強い ビーチ", "宮古島 風向き ビーチ", "宮古島 海況", ...DEFAULT_KEYWORDS],
    singleLanguage: true,
  },
  "/ocean-guide/rainy-day": {
    title: "宮古島の雨の日の過ごし方｜雨雲・カフェ・屋内スポット",
    description: "宮古島が雨の日に楽しめるカフェ、ランチ、屋内体験と、雨の合間に行動するための最新情報を紹介します。",
    keywords: ["宮古島 雨の日", "宮古島 雨 観光", "宮古島 雨雲", ...DEFAULT_KEYWORDS],
    singleLanguage: true,
  },
  "/ocean-guide/tomorrow-weather": {
    title: "宮古島の明日の天気・海況｜風・波・海遊びの予報",
    description: "宮古島の明日の天気、降水確率、風向き、風速、波、海況を確認。シュノーケルやビーチ遊びの予定を立てる前に、Ocean Guideで場所ごとの注意点を確認できます。",
    keywords: ["宮古島 明日 天気", "宮古島 明日 海況", "宮古島 明日 海", "宮古島 風 予報", ...DEFAULT_KEYWORDS],
    singleLanguage: true,
  },
  "/ocean-guide/sunset-today": {
    title: "宮古島の今日のサンセット｜日の入り時間とおすすめスポット",
    description: "宮古島の今日のサンセット情報。日の入り時間、空模様、風を確認し、17END、与那覇前浜、長間浜など夕日を楽しみやすいスポットを探せます。",
    keywords: ["宮古島 サンセット 今日", "宮古島 今日 日の入り", "宮古島 夕日 スポット", "宮古島 サンセット 時間", ...DEFAULT_KEYWORDS],
    singleLanguage: true,
  },
  "/ocean-guide/stargazing-tonight": {
    title: "宮古島の今日の星空｜雲量・月明かり・おすすめ時間",
    description: "宮古島で今夜星空が見えるか、雲量、月明かり、風から確認。星空観察に向く時間と、天気が悪い日の注意点をOcean Guideで案内します。",
    keywords: ["宮古島 星空 今日", "宮古島 今夜 星空", "宮古島 星空 時間", "宮古島 星 見える", ...DEFAULT_KEYWORDS],
    singleLanguage: true,
  },
  "/ocean-guide/after-typhoon-sea": {
    title: "宮古島の台風後の海｜海況・うねり・海遊びの注意点",
    description: "宮古島で台風後に海へ行く前の海況ガイド。晴れていても残るうねり、風、波、流れを確認し、シュノーケルやビーチ遊びの安全な判断に役立てられます。",
    keywords: ["宮古島 台風後 海", "宮古島 台風 海況", "宮古島 うねり", "宮古島 台風 シュノーケル", ...DEFAULT_KEYWORDS],
    singleLanguage: true,
  },
  "/drone-map": {
    title: "宮古島ドローンマップ｜空から探す絶景スポットと撮影ツアー",
    description:
      "宮古島の絶景スポットを地図から選び、ドローン映像でその魅力を確認できる宮古島ドローンマップ。与那覇前浜ビーチ、池間大橋、八重干瀬、秘境SUPスポットなどを紹介します。",
    keywords: [
      "宮古島 ドローンマップ",
      "宮古島 ドローン映像",
      "宮古島 絶景スポット",
      "宮古島 空撮",
      "宮古島 撮影ツアー",
      ...DEFAULT_KEYWORDS,
    ],
    image:
      "https://res.cloudinary.com/drxijtp8g/image/upload/c_fill,w_1200,h_630,q_auto,f_jpg/v1785476394/00080728-DJI_20260728114443_0018_D-light_typqqr.webp",
  },
};

const itinerarySeoByLang = {
  EN: {
    title: "Miyakojima Itinerary Planner | Routes You Can Open in Google Maps",
    description:
      "Build a relaxed Miyakojima itinerary by choosing your stay length and interests. Explore scenic tours, SUP, Yabiji, cafes, dining, and each route in Google Maps.",
    keywords: [
      "Miyakojima itinerary",
      "Miyakojima trip planner",
      "Miyakojima model course",
      "Miyakojima Google Maps",
      "Miyakojima travel route",
    ],
  },
  中文: {
    title: "宫古岛行程规划｜可直接用Google Map巡游的旅游路线",
    description:
      "选择住宿天数和想体验的项目，生成轻松的宫古岛行程。包括绝景拍摄、SUP、八重干濑、咖啡店、美食以及可直接打开的Google Map路线。",
    keywords: [
      "宫古岛行程",
      "宫古岛旅游计划",
      "宫古岛路线",
      "宫古岛Google Map",
      "宫古岛自由行",
    ],
  },
  한국어: {
    title: "미야코지마 여행 일정 플래너｜Google Map으로 여는 추천 코스",
    description:
      "숙박 일수와 원하는 체험을 선택해 여유로운 미야코지마 일정을 만드세요. 절경 촬영, SUP, 야에비지, 카페, 맛집과 Google Map 경로를 확인할 수 있습니다.",
    keywords: [
      "미야코지마 일정",
      "미야코지마 여행 플래너",
      "미야코지마 추천 코스",
      "미야코지마 Google Map",
      "미야코지마 자유여행",
    ],
  },
};

const routeSeoByLang = {
  EN: {
    "/": {
      title:
        "Private Photo Tours in Miyakojima | Drone, SUP and Secret Beaches",
      description:
        "Private Miyakojima tours for travelers who want beautiful photos, cinematic videos, drone footage, secret beaches, SUP, and a more special ocean experience.",
    },
    "/tours": {
      title: "Miyakojima Private Tours | Drone Photo Tours, SUP and Surfing",
      description:
        "Explore private Miyakojima tours with photography, drone footage, secret beaches, SUP, surfing, and relaxed one-group-only experiences.",
    },
    "/gallery": {
      title: "Miyakojima Photo and Video Gallery | Premium Tour Miyakoisland",
      description:
        "See photos, drone videos, secret beaches, SUP scenes, and cinematic travel moments from Miyakojima.",
    },
    "/faq": {
      title: "FAQ | Miyakojima Private Photo Tours",
      description:
        "Questions about Miyakojima private photo tours, booking, weather, photography, drone footage, SUP, and what to bring.",
    },
    "/contact": {
      title: "Contact and Booking | Miyakojima Private Photo Tours",
      description:
        "Contact Premium Tour Miyakoisland for private photo tours, drone shooting, SUP, surfing, and custom Miyakojima experiences.",
    },
    "/blog": {
      title: "Miyakojima Travel Blog | Cafes, Beaches and Photo Spots",
      description:
        "A Miyakojima travel blog covering cafes, scenic beaches, secret spots, food, sunset, rainy-day ideas, and photo-friendly places.",
    },
    "/ocean-guide": {
      title: "Miyako Ocean Guide | Sea Conditions, Stars and Rainy Day Ideas",
      description:
        "A Miyakojima ocean guide for sea activities, SUP, snorkeling, starry skies, rainy-day plans, spot conditions, and Google Maps routes.",
    },
    "/drone-map": {
      title: "Miyakojima Drone Map | Scenic Spots from the Sky",
      description:
        "Explore Miyakojima scenic spots through a map and drone videos, including beaches, bridges, Yabiji, and secret SUP locations.",
    },
  },
  中文: {
    "/": {
      title: "宫古岛私人摄影行程｜无人机拍摄、SUP与秘境海滩",
      description:
        "宫古岛一组限定私人行程。可体验无人机拍摄、照片和视频拍摄、秘境海滩、SUP以及特别的海上体验。",
    },
    "/tours": {
      title: "宫古岛私人行程｜无人机摄影、SUP与冲浪体验",
      description:
        "介绍宫古岛私人摄影行程、无人机拍摄、秘境SUP、冲浪和一组限定的特别体验。",
    },
    "/gallery": {
      title: "宫古岛照片・视频作品集｜Premium Tour Miyakoisland",
      description: "查看宫古岛海景、秘境海滩、无人机影像、SUP和旅行短片作品。",
    },
    "/faq": {
      title: "常见问题｜宫古岛私人摄影行程",
      description:
        "关于宫古岛私人摄影行程、预约、天气、无人机拍摄、SUP和携带物品的常见问题。",
    },
    "/contact": {
      title: "咨询与预约｜宫古岛私人摄影行程",
      description:
        "咨询宫古岛私人摄影行程、无人机拍摄、SUP、冲浪和定制旅游体验。",
    },
    "/blog": {
      title: "宫古岛旅游博客｜咖啡店、海滩与拍照景点",
      description:
        "介绍宫古岛咖啡店、绝景海滩、秘境、美食、日落、雨天玩法和适合拍照的地点。",
    },
    "/ocean-guide": {
      title: "Miyako Ocean Guide｜宫古岛海况、星空与雨天玩法",
      description:
        "宫古岛海上活动、SUP、浮潜、星空、雨天行程、景点状况和Google Map路线指南。",
    },
    "/drone-map": {
      title: "宫古岛无人机地图｜从空中寻找绝景地点",
      description:
        "通过地图和无人机影像探索宫古岛绝景地点，包括海滩、大桥、八重干濑和秘境SUP地点。",
    },
  },
  한국어: {
    "/": {
      title: "미야코지마 프라이빗 촬영 투어｜드론, SUP, 시크릿 비치",
      description:
        "사진과 영상, 드론 촬영, 시크릿 비치, SUP를 즐길 수 있는 1팀 한정 미야코지마 프라이빗 투어입니다.",
    },
    "/tours": {
      title: "미야코지마 프라이빗 투어｜드론 촬영, SUP, 서핑",
      description:
        "미야코지마 프라이빗 촬영 투어, 드론 영상, 시크릿 SUP, 서핑, 1팀 한정 특별 체험을 소개합니다.",
    },
    "/gallery": {
      title: "미야코지마 사진・영상 갤러리｜Premium Tour Miyakoisland",
      description:
        "미야코지마 바다, 시크릿 비치, 드론 영상, SUP 장면과 여행 쇼트무비를 확인해보세요.",
    },
    "/faq": {
      title: "자주 묻는 질문｜미야코지마 프라이빗 촬영 투어",
      description:
        "예약, 날씨, 촬영, 드론 영상, SUP, 준비물 등 미야코지마 프라이빗 촬영 투어 FAQ입니다.",
    },
    "/contact": {
      title: "문의・예약｜미야코지마 프라이빗 촬영 투어",
      description:
        "미야코지마 프라이빗 촬영 투어, 드론 촬영, SUP, 서핑, 맞춤 체험을 문의하세요.",
    },
    "/blog": {
      title: "미야코지마 여행 블로그｜카페, 해변, 사진 명소",
      description:
        "미야코지마 카페, 절경 해변, 숨은 명소, 맛집, 선셋, 비 오는 날 코스와 사진 명소를 소개합니다.",
    },
    "/ocean-guide": {
      title: "Miyako Ocean Guide｜미야코지마 바다 상황, 별, 비 오는 날",
      description:
        "미야코지마 바다놀이, SUP, 스노클링, 별 보기, 비 오는 날 코스, 스팟 상태와 Google Map 안내.",
    },
    "/drone-map": {
      title: "미야코지마 드론 맵｜하늘에서 보는 절경 스팟",
      description:
        "지도와 드론 영상으로 미야코지마의 해변, 다리, 야에비지, 시크릿 SUP 스팟을 둘러보세요.",
    },
  },
};

const cleanPath = (pathname) => {
  if (!pathname || pathname === "/") return "/";
  return pathname.replace(/\/+$/, "");
};

const getCurrentLang = () => {
  if (typeof window === "undefined") return "JP";

  const pathLang = window.location.pathname.split("/")[1];
  if (PATH_LANG_MAP[pathLang]) return PATH_LANG_MAP[pathLang];

  return window.localStorage.getItem(LANGUAGE_STORAGE_KEY) || "JP";
};

const absoluteUrl = (path) => `${SITE_URL}${path === "/" ? "/" : path}`;

const stripLocalePrefix = (pathname = "/") => {
  return (pathname || "/").replace(/^\/(?:en|zh|ko)(?=\/|$)/, "") || "/";
};

const buildLocalizedPath = (path = "/", lang = "JP") => {
  const normalizedPath = stripLocalePrefix(path) || "/";
  const prefix = LANG_PATH_MAP[lang];

  if (!prefix) return normalizedPath;
  if (normalizedPath === "/") return `/${prefix}`;

  return `/${prefix}${normalizedPath}`;
};

const buildAlternates = (canonicalPath) => {
  return Object.entries(LANG_PATH_MAP).map(([alternateLang]) => ({
    hreflang: URL_HREFLANG_MAP[alternateLang] || "ja",
    href: absoluteUrl(buildLocalizedPath(canonicalPath, alternateLang)),
    lang: alternateLang,
  }));
};

const normalizeDate = (value) => {
  if (!value || typeof value !== "string") return "";

  return value.replaceAll(".", "-");
};

const stripTags = (value) => {
  return String(value || "")
    .replace(/<[^>]*>/g, "")
    .replace(/\s+/g, " ")
    .trim();
};

const clampText = (value, maxLength = 155) => {
  const text = stripTags(value);

  if (text.length <= maxLength) return text;

  return `${text.slice(0, maxLength - 1).trim()}…`;
};

const getAbsoluteImageUrl = (image) => {
  if (!image) return DEFAULT_IMAGE;

  const value =
    typeof image === "string"
      ? image
      : image.image || image.url || image.src || image.thumbnail;

  if (!value || typeof value !== "string") return DEFAULT_IMAGE;
  if (value.startsWith("http")) return value;
  if (value.startsWith("/")) return `${SITE_URL}${value}`;

  return value;
};

const extractPriceNumber = (value) => {
  const match = String(value || "").match(/[\d,]+/);

  if (!match) return undefined;

  return Number(match[0].replace(/,/g, ""));
};

const uniqueList = (items) => {
  return Array.from(
    new Set(
      items
        .flat()
        .filter(Boolean)
        .map((item) => String(item).replace("#", "").trim())
        .filter(Boolean),
    ),
  );
};

const getArticleKeywords = (article) => {
  const pointKeywords = Array.isArray(article.points)
    ? article.points.flatMap((point) => [
        point.title,
        point.area,
        ...(Array.isArray(point.hashtags) ? point.hashtags : []),
      ])
    : [];

  return uniqueList([
    DEFAULT_KEYWORDS,
    article.title,
    article.category,
    article.categoryKey,
    article.toc || [],
    article.tags || [],
    pointKeywords,
  ]).slice(0, 18);
};

const getArticleImage = (article) => {
  return getAbsoluteImageUrl(
    article.mainImage ||
      article.tocImage ||
      article.image ||
      article.galleryImages?.find?.((item) => typeof item === "string") ||
      article.points?.find?.((point) => point.image)?.image,
  );
};

const getArticleSummary = (article) => {
  return clampText(
    article.description ||
      article.leadText ||
      article.text ||
      defaultDescription,
  );
};

const HIDDEN_BLOG_SLUGS = new Set([
  "jet-secret-beach-tour",
  "jet-private-secret-tour-experience",
]);

const isVisibleBlogArticle = (article) => !HIDDEN_BLOG_SLUGS.has(article?.slug);

const getBlogCollectionItems = (pathname, lang) => {
  let articles = [];

  if (pathname === "/blog") {
    articles = getAllBlogIndexArticles();
  } else if (pathname.startsWith("/blog/category/")) {
    const categoryKey = decodeURIComponent(
      pathname.replace("/blog/category/", ""),
    );

    articles = (categoryArticles?.[categoryKey] || []).filter(
      isVisibleBlogArticle,
    );
  } else if (pathname.startsWith("/blog/tag/")) {
    const tagKey = decodeURIComponent(pathname.replace("/blog/tag/", ""));

    articles = getArticlesByTag(tagKey);
  }

  return articles.slice(0, 20).map((article, index) => {
    const localizedArticle = localizeArticle(article, lang);

    return {
      "@type": "ListItem",
      position: index + 1,
      url: absoluteUrl(
        buildLocalizedPath(`/blog/${localizedArticle.slug}`, lang),
      ),
      name: localizedArticle.title,
      description: getArticleSummary(localizedArticle),
      image: getArticleImage(localizedArticle),
    };
  });
};

const getBlogArticleSeo = (pathname) => {
  const lang = getCurrentLang();
  const slug = decodeURIComponent(pathname.replace("/blog/", ""));
  const article = localizeArticle(blogArticles?.[slug], lang);

  if (!article) return null;

  return {
    title:
      lang === "JP"
        ? `${article.title}｜宮古島観光ブログ`
        : `${article.title} | Miyakojima Travel Blog`,
    description: getArticleSummary(article),
    image: getArticleImage(article),
    type: "article",
    schemaType: "blogPosting",
    slug: article.slug || slug,
    publishedTime: normalizeDate(article.date),
    modifiedTime: normalizeDate(article.updatedAt || article.date),
    section: article.category || "宮古島観光",
    keywords: getArticleKeywords(article),
    author: "Premium Tour Miyakoisland",
    locale: LOCALE_MAP[lang] || LOCALE_MAP.JP,
    article,
  };
};

const getBlogArchiveSeo = (pathname) => {
  const lang = getCurrentLang();

  if (pathname.startsWith("/blog/category/")) {
    const categoryKey = decodeURIComponent(
      pathname.replace("/blog/category/", ""),
    );
    const category = blogCategories.find((item) => item.key === categoryKey);
    const label = getLocalizedValue(category?.label, lang) || categoryKey;

    return {
      title:
        lang === "JP"
          ? `宮古島${label}情報｜観光ブログ`
          : `${label} in Miyakojima | Travel Blog`,
      description:
        lang === "JP"
          ? `宮古島旅行で知っておきたい${label}情報、撮影スポット、過ごし方をまとめています。`
          : `Articles about ${label}, photo spots, and ways to enjoy Miyakojima.`,
      type: "website",
      schemaType: "collection",
      keywords: uniqueList([DEFAULT_KEYWORDS, label, `${label} 宮古島`]),
      locale: LOCALE_MAP[lang] || LOCALE_MAP.JP,
      collectionItems: getBlogCollectionItems(pathname, lang),
    };
  }

  if (pathname.startsWith("/blog/tag/")) {
    const tagKey = decodeURIComponent(pathname.replace("/blog/tag/", ""));
    const tag = blogTagLinks.find((item) => item.key === tagKey);
    const label = getLocalizedValue(tag?.label, lang) || `#${tagKey}`;

    return {
      title:
        lang === "JP"
          ? `${label}の記事一覧｜宮古島観光ブログ`
          : `${label} Articles | Miyakojima Travel Blog`,
      description:
        lang === "JP"
          ? `宮古島旅行の${label}に関する記事一覧です。観光、撮影、ツアー選びの参考にしてください。`
          : `Articles about ${label} for sightseeing, photography, and tour planning in Miyakojima.`,
      type: "website",
      schemaType: "collection",
      keywords: uniqueList([DEFAULT_KEYWORDS, label, `${label} 宮古島`]),
      locale: LOCALE_MAP[lang] || LOCALE_MAP.JP,
      collectionItems: getBlogCollectionItems(pathname, lang),
    };
  }

  return null;
};

const getTourSeo = (pathname) => {
  const lang = getCurrentLang();
  const slug = decodeURIComponent(pathname.replace(/^\/tours?\//, ""));
  const tour = tourDetails?.[lang]?.[slug] || tourDetails?.JP?.[slug];

  if (!tour) return null;

  return {
    title:
      lang === "JP"
        ? `${tour.heroTitle || tour.title}｜宮古島貸切フォトツアー`
        : `${tour.heroTitle || tour.title} | Private Miyakojima Photo Tour`,
    description: tour.heroDescription || tour.description || defaultDescription,
    image: tour.heroImage || tour.images?.[0],
    type: "product",
    schemaType: "tour",
    tour,
    price:
      extractPriceNumber(tour.heroPrice) ||
      extractPriceNumber(tour.price?.items?.[0]?.price),
    keywords: uniqueList([
      DEFAULT_KEYWORDS,
      tour.title,
      tour.heroTitle,
      tour.pathTitle,
      tour.highlights || [],
      tour.included || [],
      tour.detailItems?.flat?.() || [],
    ]).slice(0, 20),
    locale: LOCALE_MAP[lang] || LOCALE_MAP.JP,
  };
};

export const getSeoForLocation = (location) => {
  const lang = getCurrentLang();
  const requestedPath = cleanPath(location?.pathname || "/");
  const pathname = stripLocalePrefix(requestedPath);
  const canonicalPath = pathname.startsWith("/tour/")
    ? pathname.replace("/tour/", "/tours/")
    : pathname;
  const dynamicSeo =
    (pathname === HOTEL_GUIDE_PATH && hotelGuideSeo) ||
    getOceanPlaceSeo(pathname) ||
    (pathname.startsWith("/blog/category/") && getBlogArchiveSeo(pathname)) ||
    (pathname.startsWith("/blog/tag/") && getBlogArchiveSeo(pathname)) ||
    (pathname.startsWith("/blog/") && getBlogArticleSeo(pathname)) ||
    ((pathname.startsWith("/tours/") || pathname.startsWith("/tour/")) &&
      getTourSeo(pathname));

  const seo = dynamicSeo || routeSeo[pathname] || {
    title: "ページが見つかりません | Ocean Guide Miyakojima",
    description: "お探しのページは見つかりませんでした。Ocean Guideから宮古島の最新情報をご確認ください。",
    singleLanguage: true,
    noindex: true,
  };
  const routeTranslation = routeSeoByLang[lang]?.[pathname];
  const localizedSeo =
    pathname === "/itinerary" && lang !== "JP"
      ? {
          ...seo,
          ...itinerarySeoByLang[lang],
          locale: LOCALE_MAP[lang] || LOCALE_MAP.JP,
        }
      : pathname === "/blog" && lang !== "JP"
        ? {
            ...seo,
            title: `${blogText[lang]?.heroTitle?.join(" ") || "Miyakojima Travel Guide"} | ${SITE_NAME}`,
            description:
              blogText[lang]?.heroDescription ||
              "A Miyakojima travel blog with cafes, food, scenic drives, and photo spots.",
            locale: LOCALE_MAP[lang] || LOCALE_MAP.JP,
          }
        : routeTranslation
          ? {
              ...seo,
              ...routeTranslation,
              locale: LOCALE_MAP[lang] || LOCALE_MAP.JP,
            }
          : seo;

  return {
    ...localizedSeo,
    canonical: absoluteUrl(localizedSeo.singleLanguage ? canonicalPath : buildLocalizedPath(canonicalPath, lang)),
    image: localizedSeo.image || DEFAULT_IMAGE,
    keywords: localizedSeo.keywords || DEFAULT_KEYWORDS,
    type: localizedSeo.type || "website",
    locale: localizedSeo.locale || LOCALE_MAP[lang] || LOCALE_MAP.JP,
    alternates: localizedSeo.singleLanguage
      ? [{ hreflang: "ja", href: absoluteUrl(canonicalPath) }]
      : buildAlternates(canonicalPath),
    collectionItems:
      localizedSeo.collectionItems ||
      (pathname === "/blog"
        ? getBlogCollectionItems(pathname, lang)
        : undefined),
  };
};

const upsertMeta = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    if (value) {
      element.setAttribute(key, value);
    }
  });
};

const upsertLink = (rel, href) => {
  let element = document.head.querySelector(`link[rel="${rel}"]`);

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }

  element.setAttribute("href", href);
};

const syncAlternateLinks = (alternates = []) => {
  document.head
    .querySelectorAll('link[rel="alternate"][hreflang]')
    .forEach((element) => element.remove());

  alternates.forEach(({ hreflang, href }) => {
    const element = document.createElement("link");
    element.rel = "alternate";
    element.hreflang = hreflang;
    element.href = href;
    document.head.appendChild(element);
  });

  if (alternates.length > 0) {
    const fallback = alternates.find(({ hreflang }) => hreflang === "ja");
    const element = document.createElement("link");
    element.rel = "alternate";
    element.hreflang = "x-default";
    element.href = fallback?.href || alternates[0].href;
    document.head.appendChild(element);
  }
};

const removeMeta = (selector) => {
  document.head.querySelectorAll(selector).forEach((element) => {
    element.remove();
  });
};

const syncArticleTagMeta = (keywords = []) => {
  removeMeta('meta[property="article:tag"]');

  keywords.slice(0, 12).forEach((keyword) => {
    const element = document.createElement("meta");
    element.setAttribute("property", "article:tag");
    element.setAttribute("content", keyword);
    document.head.appendChild(element);
  });
};

const upsertStructuredData = (seo) => {
  let element = document.head.querySelector(
    'script[data-seo="structured-data"]',
  );

  if (!element) {
    element = document.createElement("script");
    element.type = "application/ld+json";
    element.dataset.seo = "structured-data";
    document.head.appendChild(element);
  }

  if (seo.structuredData) {
    element.textContent = JSON.stringify(seo.structuredData);
    return;
  }

  const pageType =
    seo.type === "article"
      ? "BlogPosting"
      : seo.schemaType === "collection"
        ? "CollectionPage"
        : "WebPage";

  const graph = [
    {
      "@type": "WebSite",
      "@id": `${SITE_URL}/#website`,
      name: SITE_NAME,
      url: SITE_URL,
      inLanguage: seo.locale,
      potentialAction: {
        "@type": "SearchAction",
        target: `${SITE_URL}/blog?keyword={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "LocalBusiness",
      "@id": `${SITE_URL}/#localbusiness`,
      name: SITE_NAME,
      url: SITE_URL,
      image: seo.image || DEFAULT_IMAGE,
      description: defaultDescription,
      areaServed: {
        "@type": "Place",
        name: "宮古島",
      },
      address: {
        "@type": "PostalAddress",
        addressLocality: "宮古島市",
        addressRegion: "沖縄県",
        addressCountry: "JP",
      },
      sameAs: [INSTAGRAM_URL],
    },
    {
      "@type": pageType,
      "@id": `${seo.canonical}#webpage`,
      name: seo.title,
      headline: seo.title,
      description: seo.description,
      url: seo.canonical,
      image: seo.image,
      keywords: seo.keywords,
      inLanguage: seo.locale,
      isPartOf: {
        "@id": `${SITE_URL}/#website`,
      },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: SITE_URL,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: seo.title,
          item: seo.canonical,
        },
      ],
    },
  ];

  const pageNodeIndex = 2;

  if (seo.schemaType === "itinerary" || seo.schemaType === "oceanGuide") {
    graph.push({
      "@type": "WebApplication",
      "@id": `${seo.canonical}#planner`,
      name: seo.title,
      description: seo.description,
      url: seo.canonical,
      applicationCategory: "TravelApplication",
      operatingSystem: "Web",
      inLanguage: seo.locale,
      isPartOf: { "@id": `${SITE_URL}/#website` },
    });
  }

  if (seo.schemaType === "professionalService") {
    graph.push({
      "@type": "ProfessionalService",
      "@id": `${seo.canonical}#service`,
      name: "宮古島のWeb制作・ホームページ制作",
      description: seo.description,
      url: seo.canonical,
      image: seo.image || DEFAULT_IMAGE,
      areaServed: {
        "@type": "City",
        name: "宮古島市",
      },
      serviceType: [
        "Web制作",
        "ホームページ制作",
        "Webデザイン",
        "SEO対策",
        "MEO対策",
        "Googleビジネスプロフィール最適化",
        "多言語サイト制作",
      ],
      offers: {
        "@type": "Offer",
        price: "200000",
        priceCurrency: "JPY",
        description: "残り1社様限定キャンペーン価格（通常価格400,000円）",
        url: seo.canonical,
      },
      provider: {
        "@id": `${SITE_URL}/#localbusiness`,
      },
      audience: {
        "@type": "BusinessAudience",
        audienceType: "宮古島市のツアー会社・飲食店・宿泊施設・地域事業者",
      },
    });

    graph.push({
      "@type": "FAQPage",
      "@id": `${seo.canonical}#faq`,
      mainEntity: [
        ["ほかのWeb制作会社との違いは何ですか？", "制作会社によっては簡単な変更だけでも運用費・管理費が毎月発生し、長期的には大きな固定費になりますが、成果につなげる改善まで含まれているとは限りません。契約前に具体的な成果と月額費用に含まれる対応内容を確認することが大切です。私たちはその固定費をいただかず、プロが品質を担保しながら、お客様自身で長期的に運用できる状態までつくります。"],
        ["宮古島でホームページ制作を依頼すると、料金はいくらですか？", "通常価格400,000円（税込）のところ、現在は残り1社様限定のキャンペーン価格200,000円（20万円・税込）です。ページ数が多い場合や、予約・決済など複雑な機能が必要な場合は、ヒアリング後に正確なお見積もりをご提示します。"],
        ["公開後の運用費や管理費はかかりますか？", "運用費・管理費は0円です。サーバーや外部サービスの利用状況によって実費が発生する場合はあります。"],
        ["ホームページ公開後、自分で更新できますか？", "はい。誰でも操作しやすい管理画面をご用意し、AIを使った更新や改善方法も含めて長期的に自走できる体制づくりまでサポートします。"],
        ["すでにあるホームページのリニューアルも依頼できますか？", "対応可能です。SEO、情報設計、問い合わせ・予約導線、公開後の運用方法まで見直して再設計します。"],
        ["ホームページはどのくらいの期間で完成しますか？", "シンプルなホームページは通常1か月以内が目安です。準備と確認が順調な場合は最短1週間ほどで公開できる場合があります。"],
      ].map(([name, text]) => ({
        "@type": "Question",
        name,
        acceptedAnswer: { "@type": "Answer", text },
      })),
    });

    graph[pageNodeIndex] = {
      ...graph[pageNodeIndex],
      mainEntity: {
        "@id": `${seo.canonical}#service`,
      },
    };
  }

  if (seo.type === "article") {
    graph[pageNodeIndex] = {
      ...graph[pageNodeIndex],
      "@type": seo.schemaType === "blogPosting" ? "BlogPosting" : "Article",
      author: {
        "@type": "Organization",
        name: seo.author || SITE_NAME,
        url: SITE_URL,
      },
      publisher: {
        "@type": "Organization",
        name: SITE_NAME,
        logo: {
          "@type": "ImageObject",
          url: `${SITE_URL}/images/logo_new.png`,
        },
      },
      datePublished: seo.publishedTime,
      dateModified: seo.modifiedTime || seo.publishedTime,
      articleSection: seo.section,
      keywords: seo.keywords,
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": seo.canonical,
      },
    };
  }

  if (
    seo.schemaType === "collection" &&
    Array.isArray(seo.collectionItems) &&
    seo.collectionItems.length > 0
  ) {
    graph.push({
      "@type": "ItemList",
      "@id": `${seo.canonical}#itemlist`,
      name: seo.title,
      description: seo.description,
      numberOfItems: seo.collectionItems.length,
      itemListElement: seo.collectionItems,
    });

    graph[pageNodeIndex] = {
      ...graph[pageNodeIndex],
      mainEntity: {
        "@id": `${seo.canonical}#itemlist`,
      },
    };
  }

  if (seo.schemaType === "tour" && seo.tour) {
    const tour = seo.tour;
    const productNode = {
      "@type": "Product",
      "@id": `${seo.canonical}#product`,
      name: tour.heroTitle || tour.title,
      description: stripTags(tour.heroDescription || tour.description),
      image: [tour.heroImage || tour.images?.[0], ...(tour.images || [])]
        .filter(Boolean)
        .slice(0, 8),
      brand: {
        "@type": "Brand",
        name: SITE_NAME,
      },
      category: "宮古島 貸切ツアー",
      areaServed: "宮古島",
      offers: {
        "@type": "Offer",
        url: seo.canonical,
        priceCurrency: "JPY",
        ...(seo.price ? { price: seo.price } : {}),
        availability: "https://schema.org/InStock",
      },
    };

    const tripNode = {
      "@type": "TouristTrip",
      "@id": `${seo.canonical}#tour`,
      name: tour.heroTitle || tour.title,
      description: stripTags(tour.heroDescription || tour.description),
      image: tour.heroImage || tour.images?.[0],
      touristType: "宮古島旅行者",
      itinerary: (tour.scheduleItems || []).slice(0, 8).map((item) => ({
        "@type": "ListItem",
        name: item.title || item.scheduleTitle,
        description: item.text || item.scheduleText,
      })),
      provider: {
        "@id": `${SITE_URL}/#localbusiness`,
      },
    };

    graph.push(productNode, tripNode);

    if (Array.isArray(tour.faqs) && tour.faqs.length > 0) {
      graph.push({
        "@type": "FAQPage",
        "@id": `${seo.canonical}#faq`,
        mainEntity: tour.faqs.slice(0, 10).map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: stripTags(item.answer),
          },
        })),
      });
    }
  }

  element.textContent = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": graph,
  });
};

export const updateDocumentSeo = (seo) => {
  if (typeof document === "undefined") return;

  document.title = seo.title;

  upsertMeta('meta[name="description"]', {
    name: "description",
    content: seo.description,
  });
  upsertMeta('meta[name="robots"]', {
    name: "robots",
    content: seo.noindex
      ? "noindex, nofollow, noarchive"
      : "index, follow, max-image-preview:large",
  });
  upsertMeta('meta[name="keywords"]', {
    name: "keywords",
    content: seo.keywords.join(", "),
  });
  upsertLink("canonical", seo.canonical);
  syncAlternateLinks(seo.alternates || []);

  upsertMeta('meta[property="og:title"]', {
    property: "og:title",
    content: seo.title,
  });
  upsertMeta('meta[property="og:description"]', {
    property: "og:description",
    content: seo.description,
  });
  upsertMeta('meta[property="og:type"]', {
    property: "og:type",
    content: seo.type,
  });
  upsertMeta('meta[property="og:url"]', {
    property: "og:url",
    content: seo.canonical,
  });
  upsertMeta('meta[property="og:image"]', {
    property: "og:image",
    content: seo.image,
  });
  upsertMeta('meta[property="og:site_name"]', {
    property: "og:site_name",
    content: SITE_NAME,
  });
  upsertMeta('meta[property="og:locale"]', {
    property: "og:locale",
    content: seo.locale || "ja_JP",
  });

  if (seo.type === "article") {
    upsertMeta('meta[property="article:published_time"]', {
      property: "article:published_time",
      content: seo.publishedTime,
    });
    upsertMeta('meta[property="article:modified_time"]', {
      property: "article:modified_time",
      content: seo.modifiedTime || seo.publishedTime,
    });
    upsertMeta('meta[property="article:section"]', {
      property: "article:section",
      content: seo.section,
    });
    syncArticleTagMeta(seo.keywords);
  } else {
    removeMeta('meta[property^="article:"]');
  }

  upsertMeta('meta[name="twitter:card"]', {
    name: "twitter:card",
    content: "summary_large_image",
  });
  upsertMeta('meta[name="twitter:title"]', {
    name: "twitter:title",
    content: seo.title,
  });
  upsertMeta('meta[name="twitter:description"]', {
    name: "twitter:description",
    content: seo.description,
  });
  upsertMeta('meta[name="twitter:image"]', {
    name: "twitter:image",
    content: seo.image,
  });

  upsertStructuredData(seo);
};
